export default function TabPanel({ className = '', value, index, children }) {
  return value === index ? <div className={className}>{children}</div> : null;
}
